import React from 'react'
import { withRouter, Link } from 'react-router-dom'
import { routes } from '../../routes/routePaths'
import { BreadBox } from './styles'
import { BiChevronRight } from 'react-icons/bi'
import extractPaths from '../../utils/extractPaths'
import { fillPathParams } from '../../utils/fillPathParams'

const Breadcrumbs = ({ location }) => {
  const paths = extractPaths(location.pathname)

  let crumbs = paths
    .map((pathSchema, idx) => {
      const route = routes.find((r) => r.path === pathSchema)
      if (route) {
        // If is the last path, don't add a link
        const isLast = idx === paths.length - 1

        // Fill path params into the path
        const pathWithParams = fillPathParams(location.pathname, pathSchema)

        return !isLast ? (
          <Link to={pathWithParams} key={route.id}>
            {route.name}
          </Link>
        ) : (
          <span key={route.id}>{route.name}</span>
        )
      }
      return null
    })
    .filter(Boolean)

  crumbs.shift()

  return (
    <BreadBox>
      <ul>
        {crumbs?.map?.((content, idx) => {
          if (crumbs.length - idx > 1) {
            return (
              <li key={idx}>
                {content}
                <BiChevronRight size={20} />
              </li>
            )
          }
          return <li key={idx}>{content}</li>
        })}
      </ul>
    </BreadBox>
  )
}

export default withRouter(Breadcrumbs)
